/**
 * Contexto de la sesion del backoffice y el hook para leerlo.
 *
 * Esta separado de `sesion.tsx` porque el recargado en caliente de Vite solo
 * funciona si un archivo exporta unicamente componentes: con el proveedor y el
 * hook juntos, cada cambio en el proveedor recargaria la pagina entera en vez
 * del componente.
 */
import { createContext, useContext } from 'react';

import type { Administrador, CredencialesDto } from '@bandu/compartido';

/** `comprobando` es el estado inicial: hay un token pero todavia no se valida. */
export type EstadoSesion = 'comprobando' | 'dentro' | 'fuera';

export interface ValorSesion {
  estado: EstadoSesion;
  administrador: Administrador | null;
  entrar(credenciales: CredencialesDto): Promise<void>;
  salir(): void;
  /** Refresca los datos tras un cambio propio (cambiar la clave, por ejemplo). */
  actualizar(administrador: Administrador): void;
}

export const ContextoSesion = createContext<ValorSesion | null>(null);

export function useSesion(): ValorSesion {
  const valor = useContext(ContextoSesion);

  if (valor === null) {
    throw new Error('useSesion se uso fuera de <ProveedorSesion>');
  }

  return valor;
}
